import { Injectable } from '@angular/core';
import { StorageManager } from '@services/storage-manager.service';
import { setCookie } from '@lib/cookies';
import { CookieKey } from '@lib/cookie-keys.const';
import { cookieDomain, cookiePath, removeAuthToken } from '@lib/logout-utils';

@Injectable({
  providedIn: 'root',
})
export class CompanySwitcherSessionService {
  constructor(private storageManager: StorageManager) {}

  public clearCookies(): Promise<boolean> {
    return this.storageManager.clearLocalStorage().then(() => {
      removeAuthToken();
      return Promise.resolve(true);
    });
  }

  public setAuthToken(token: string): void {
    setCookie(CookieKey.AUTH_TOKEN, token, { path: cookiePath, domain: cookieDomain });
  }
}
